import { useNavigate } from 'react-router-dom';
import LogoImage from '../../assets/logo.png';

const Logo = () => {
  const navigate = useNavigate();

  return (
    <img
      style={{
        width: '200px',
        height: '31.7px',
        cursor: 'pointer',
      }}
      src={LogoImage}
      onClick={() => navigate('/upload')}
    ></img>
  );
};

export default Logo;
